import { render, staticRenderFns } from "./BKData.vue?vue&type=template&id=1a4fb16e&"
import script from "./BKData.vue?vue&type=script&lang=ts&"
export * from "./BKData.vue?vue&type=script&lang=ts&"
import style0 from "./BKData.vue?vue&type=style&index=0&id=1a4fb16e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports